import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowDiagonalUpLeft$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowDiagonalUpLeft extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9ce0f2faa7ff061e27c25179ddf999ecf7c61b49', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '88e411f7fef66ece743d6fa4c68bd37580c456fc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '004c91bbdf660dcd313a1e3649be898d84a50e18', d: "M8.416 7.36h4.448a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-6.5a.5.5 0 0 0-.355.148.5.5 0 0 0-.15.356v6.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V8.425l7.58 7.579a.5.5 0 0 0 .707 0l.353-.354a.5.5 0 0 0 0-.707z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-diagonal-up-left", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-diagonal-up-left"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-diagonal-up-left":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowDiagonalUpLeft$1);
            }
            break;
    } });
}

const CosmosIconArrowDiagonalUpLeft = CosmosIconArrowDiagonalUpLeft$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowDiagonalUpLeft, defineCustomElement };
